export default __webpack_public_path__ + "static/media/Group 3203.74d7a6ac.jpg";